import { styled } from '@material-ui/core';
import { styled as styledBase } from 'styled-components';
import { SButton } from '@setvi/shared/components';
import { RefreshGradientIcon } from '@setvi/shared/components/sicons';
import { TextColor } from '@setvi/shared/enums';

export const ReEnhanceButton = styled(SButton)({
  borderRadius: '120px',
  color: TextColor.Blue,
  fontSize: '12px',
  fontWeight: 600,
  minHeight: 0
});

export const ReEnhanceIcon = styledBase(RefreshGradientIcon).withConfig({
  shouldForwardProp: prop => prop !== 'gridColumn' && prop !== 'spanRows'
})<{
  disabled?: boolean;
}>(({ disabled }) => ({
  width: '16px',
  height: '16px',
  '& path': {
    ...(disabled ? { fill: '#00000042' } : {})
  }
}));
